export enum UserCategory {
  Regular = 'Regular',
  Integration = 'Integration',
}
